<section [class]="cssClass">
    <ng-content></ng-content>    
</section>